"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetInputState = exports.Form = void 0;
var s_js_1 = require("s-js");
var Surplus = require("surplus");
var form_state_1 = require("./form-state");
var Form = function (props) {
    var _a, _b;
    var formProps = __assign(__assign({}, props), { preventAction: (_a = props.preventAction) !== null && _a !== void 0 ? _a : true });
    delete formProps.children;
    delete formProps.value;
    delete formProps.onReset;
    delete formProps.onSubmit;
    if ((_b = props.preventAction) !== null && _b !== void 0 ? _b : true) {
        delete formProps.method;
        delete formProps.action;
    }
    else {
        if (!formProps.method)
            formProps.method = "post";
    }
    return (<form {...formProps} name={props.name || "form"} autoComplete="off" noValidate onReset={handleReset} onSubmit={handleSubmit}>
            {props.children}
        </form>);
    function handleReset(ev) {
        var _a;
        ev.preventDefault();
        ev.stopPropagation();
        s_js_1.default.freeze(function () {
            var status = s_js_1.default.sample(props.value.status);
            form_state_1.resetStatus(status);
            props.value.status(status);
            props.value.inputs.forEach(function (sig) {
                var curr = s_js_1.default.sample(sig);
                resetInputState(curr);
                sig(curr);
            });
        });
        (_a = props.onReset) === null || _a === void 0 ? void 0 : _a.call(props);
    }
    function handleSubmit(ev) {
        var _a;
        var form = props.value;
        form_state_1.touchAllInputs(form);
        var canSubmit = form.status().isValid && (props.onSubmit ? props.onSubmit() : true);
        var status = s_js_1.default.sample(form.status);
        status.submissions += 1;
        status.isSubmitted = canSubmit ? true : status.isSubmitted;
        form.status(status);
        // Prevent default behaviour of form (POSTing)
        if (!canSubmit || ((_a = props.preventAction) !== null && _a !== void 0 ? _a : true)) {
            ev.stopPropagation();
            ev.preventDefault();
            return false;
        }
    }
};
exports.Form = Form;
function resetInputState(input) {
    input.error = 0;
    input.__v = 0;
    input.isChanged = false;
    input.isTouched = false;
    input.isDisabled = input.startDisabled;
    if ("isArrayInput" in input) {
        // TODO: need better typing suport
        input.value(input.startValue.map(function (it, i) {
            return s_js_1.default.data(form_state_1.inputState(input.name + i, it));
        }));
    }
    else {
        input.value = input.startValue;
    }
}
exports.resetInputState = resetInputState;
//# sourceMappingURL=Form.jsx.map